export function isDefined(value) {
    return typeof value !== 'undefined';
}
